import React from 'react';
import './App.scss';
import CustomCanvas from "components/custom-canvas/CustomCanvas";

const App = () => {
    return (
        <CustomCanvas/>
    );
}

export default App;
